import { BreakpointObserver } from '@angular/cdk/layout';
import { config } from '../app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/layout";
var MqService = /** @class */ (function () {
    function MqService(bpObserver, window) {
        this.bpObserver = bpObserver;
        this.desktopMediaQuery = config.desktopMediaQuery || '(min-width: 768px)';
        this.tabletMediaQuery = '(min-width: 1024px)';
    }
    MqService.prototype.mqFactory = function (mediaQuery) {
        var _this = this;
        return function (left, right) {
            return _this.bpObserver
                .observe(mediaQuery)
                .subscribe(function (state) {
                return state.matches ? right() : left();
            });
        };
    };
    MqService.prototype.mobileDesktop = function (mobile, desktop) {
        return this.mqFactory(this.desktopMediaQuery)(mobile, desktop);
    };
    MqService.prototype.tabletDesktop = function (tablet, desktop) {
        return this.mqFactory(this.tabletMediaQuery)(tablet, desktop);
    };
    MqService.prototype.isTabletAndLaptop = function () {
        return window.innerWidth > 768 && window.innerWidth < 1440;
    };
    MqService.prototype.isTablet = function () {
        return window.innerWidth > 768 && window.innerWidth < 1024;
    };
    MqService.prototype.isMidi = function () {
        return window.innerWidth <= 1024;
    };
    MqService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MqService_Factory() { return new MqService(i0.ɵɵinject(i1.BreakpointObserver), i0.ɵɵinject("Window")); }, token: MqService, providedIn: "root" });
    return MqService;
}());
export { MqService };
